import { RestfulModel } from 'app/model/restful-model';
import { RootState } from 'app/store';

import { SliceState } from './slice-state';

// change '.sliceName' to the name you register the slice in your RootState
const toSliceState = (state: RootState): SliceState => state.resolver;

export const selectResolvedValue =
    <T extends RestfulModel<number | string>>(name: string, id: number | string | undefined) =>
    (state: RootState): T | undefined => {
        const currentVal = toSliceState(state).resolvedMap[name];
        if (!currentVal) {
            return undefined;
        }

        if (String(currentVal.id) === String(id) || ('new' === id && currentVal.id === undefined)) {
            return currentVal as T;
        }

        return undefined;
    };
